import { React } from 'react';
import { Link } from 'react-router-dom';
import AuthService from '../../services/authService';

const LeftSide = () => {
    return (
        <div className="left-side-menu">
            <div className="h-100" data-simplebar>
                {/* <!-- User box --> */}
                <div className="user-box text-center">
                    <img
                        src="assets/images/users/user-1.jpg"
                        alt="user-img"
                        title="Mat Helme"
                        className="rounded-circle img-thumbnail avatar-md"
                    />

                    <p className="text-muted left-user-info">Admin Head</p>

                    <ul className="list-inline">
                        <li className="list-inline-item">
                            <Link to="#" className="text-muted left-user-info">
                                <i className="mdi mdi-cog"></i>
                            </Link>
                        </li>

                        <li className="list-inline-item">
                            <Link to="#">
                                <i className="mdi mdi-power"></i>
                            </Link>
                        </li>
                    </ul>
                </div>

                {/* <!--- Sidemenu --> */}
                <div id="sidebar-menu">
                    <ul id="side-menu">
                        <li className="menu-title mt-2 fw-bold" style={{ fontSize: '1.2rem' }}>
                            네이버
                        </li>

                        <li>
                            <Link to="/keywordVer1">
                                <i className="mdi mdi-chart-bar"></i>
                                <span> 키워드 추출 순위 Ver1 </span>
                            </Link>
                        </li>

                        <li>
                            <Link to="/keywordVer2">
                                <i className="mdi mdi-chart-bar-stacked"></i>
                                <span> 키워드 추출 순위 Ver2 </span>
                            </Link>
                        </li>

                        <li>
                            <Link to="/findMid">
                                <i className="mdi mdi-file-find-outline"></i>
                                <span> MID 조회 </span>
                            </Link>
                        </li>

                        {/* <li>
                            <Link to="/FindNaverRank">
                                <i className="mdi mdi-file-find-outline"></i>
                                <span> 네이버 순위 조회 </span>
                            </Link>
                        </li> */}
                        <li>
                            <Link to="/FindNaverRankTracking">
                                <i className="mdi mdi-file-find-outline"></i>
                                <span> 네이버 순위 추적 </span>
                            </Link>
                        </li>
                    </ul>
                </div>
                {/* <!-- End Sidebar --> */}

                <div className="clearfix"></div>
            </div>
            {/* <!-- Sidebar -left --> */}
        </div>
    );
};
export { LeftSide };
